// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Vuetify from "vuetify";
import VueScrollTo from "vue-scrollto";
import AnimatedCss from 'animate.css';

Vue.use(AnimatedCss);
Vue.use(Vuetify);
Vue.use(VueScrollTo);
import("../node_modules/vuetify/dist/vuetify.min.css");
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js